<template>
  <header class="navbar" :class="{ scrolled: isScrolled }">

    <div class="container navbar-container">

      <!-- LOGO -->
      <router-link
        to="/"
        class="logo"
      >

        <div class="logo-wrapper">
          <img
            src="@/assets/logo_groupeviras.jpeg"
            alt="Groupe VIRAS"
          />
        </div>

        <div class="logo-text">
          <h2>Groupe VIRAS</h2>
          <span>Innovation • Excellence</span>
        </div>

      </router-link>

      <!-- HAMBURGER -->
      <div
        class="hamburger"
        @click="toggleMobileMenu"
      >

        <span :class="{ open: mobileMenuOpen }"></span>
        <span :class="{ open: mobileMenuOpen }"></span>
        <span :class="{ open: mobileMenuOpen }"></span>

      </div>

      <!-- MENU -->
      <nav :class="['menu', { 'mobile-open': mobileMenuOpen }]">

       <router-link
  to="/"
  @click="closeMobileMenu"
>
  <i class="bi bi-house-door-fill"></i>
  Accueil
</router-link>

<router-link
  to="/actualites"
  @click="closeMobileMenu"
>
  <i class="bi bi-megaphone-fill"></i>
  Actualités
</router-link>

        <router-link
          to="/groupe"
          @click="closeMobileMenu"
        >
          <i class="bi bi-buildings-fill"></i>
          Le Groupe
        </router-link>

        <!-- FILIALES -->
        <div
          class="dropdown"
          @mouseleave="closeDropdownOnDesktop('filiales')"
        >

          <a
            href="#"
            @mouseover="openDropdownOnDesktop('filiales')"
            @click.prevent="toggleDropdown('filiales')"
          >
            <div class="nav-link-content">
              <i class="bi bi-diagram-3-fill"></i>
              Filiales
            </div>

            <i
              class="bi bi-chevron-down dropdown-icon"
              :class="{ rotate: openMenu === 'filiales' }"
            ></i>
          </a>

          <ul
            :class="[
              'dropdown-menu',
              { show: openMenu === 'filiales' }
            ]"
          >

            <li>
              <router-link
                to="/filiales/louga-voyages"
                @click="closeMobileMenu"
              >
                <i class="bi bi-airplane-fill"></i>
                Louga Voyages
              </router-link>
            </li>
             <li>
              <router-link
                to="/filiales/maison-viras"
                @click="closeMobileMenu"
              >
                <i class="bi bi-gem"></i>
                Maison Viras
              </router-link>
            </li>
            <li>
    <router-link
      to="/filiales/viras-technologies"
      @click="closeMobileMenu"
    >
      <i class="bi bi-cpu-fill"></i>
      VIRAS Technologies
    </router-link>
  </li>


            <li>
              <router-link
                to="/filiales/saveur-deco"
                @click="closeMobileMenu"
              >
                <i class="bi bi-cup-hot-fill"></i>
                Saveurs N’Déco
              </router-link>
            </li>

            <li>
              <router-link
                to="/filiales/lamien-consulting"
                @click="closeMobileMenu"
              >
                <i class="bi bi-briefcase-fill"></i>
                Lamien Consulting
              </router-link>
            </li>

            <li>
              <router-link
                to="/filiales/clinique-demassi"
                @click="closeMobileMenu"
              >
                <i class="bi bi-hospital-fill"></i>
                Clinique DemAssi
              </router-link>
            </li>

            <li>
              <router-link
                to="/filiales/baraka-boutique"
                @click="closeMobileMenu"
              >
                <i class="bi bi-bag-fill"></i>
                Boutique Baraka
              </router-link>
            </li>

            <li>
              <router-link
                to="/filiales/pool-formation"
                @click="closeMobileMenu"
              >
                <i class="bi bi-mortarboard-fill"></i>
                Pool Formation
              </router-link>
            </li>

            <li>
              <router-link
                to="/filiales/centre-almanassik"
                @click="closeMobileMenu"
              >
                <i class="bi bi-moon-stars-fill"></i>
                Centre Almanassik
              </router-link>
            </li>

          </ul>

        </div>

        <!-- SERVICES -->
        <div
          class="dropdown"
          @mouseleave="closeDropdownOnDesktop('services')"
        >

          <a
            href="#"
            @mouseover="openDropdownOnDesktop('services')"
            @click.prevent="toggleDropdown('services')"
          >

            <div class="nav-link-content">
              <i class="bi bi-grid-1x2-fill"></i>
              Services
            </div>

            <i
              class="bi bi-chevron-down dropdown-icon"
              :class="{ rotate: openMenu === 'services' }"
            ></i>

          </a>

          <ul
            :class="[
              'dropdown-menu',
              { show: openMenu === 'services' }
            ]"
          >

            <li>
              <router-link
                to="/services/voyages"
                @click="closeMobileMenu"
              >
                <i class="bi bi-airplane-engines-fill"></i>
                Voyages
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/visa-assurances"
                @click="closeMobileMenu"
              >
                <i class="bi bi-passport-fill"></i>
                Visa & Assurances
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/transport"
                @click="closeMobileMenu"
              >
                <i class="bi bi-truck-front-fill"></i>
                Transport & Transit
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/transfert-argent"
                @click="closeMobileMenu"
              >
                <i class="bi bi-cash-stack"></i>
                Transfert d’Argent
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/evenements"
                @click="closeMobileMenu"
              >
                <i class="bi bi-calendar-event-fill"></i>
                Événements
              </router-link>
            </li>

            <li>
              <router-link
                to="/services/marketing"
                @click="closeMobileMenu"
              >
                <i class="bi bi-megaphone-fill"></i>
                Marketing
              </router-link>
            </li>

          </ul>

        </div>

        <!-- CONTACT -->
        <router-link
          to="/contact"
          class="contact-link"
          @click="closeMobileMenu"
        >
          <i class="bi bi-envelope-fill"></i>
          Contact
        </router-link>

      </nav>

    </div>

  </header>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const openMenu = ref(null)
const mobileMenuOpen = ref(false)
const isDesktop = ref(window.innerWidth >= 992)
const isScrolled = ref(false)

/* RESIZE */

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 992

  if (isDesktop.value) {
    mobileMenuOpen.value = false
  }
}

/* SCROLL */

const handleScroll = () => {
  isScrolled.value = window.scrollY > 20
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', handleScroll)
})

/* DROPDOWN */

function toggleDropdown(menu) {
  openMenu.value =
    openMenu.value === menu ? null : menu
}

function closeMobileMenu() {
  mobileMenuOpen.value = false
  openMenu.value = null
}

function openDropdownOnDesktop(menu) {
  if (isDesktop.value) {
    openMenu.value = menu
  }
}

function closeDropdownOnDesktop() {
  if (isDesktop.value) {
    openMenu.value = null
  }
}

/* MOBILE */

function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
}
</script>
<style scoped>

/* =========================
   NAVBAR
========================= */

.navbar{
  position:fixed;
  top:0;
  left:0;
  width:100%;

  z-index:1000;

  padding:18px 0;

  transition:0.4s ease;

  background:
    rgba(15,43,69,0.75);

  backdrop-filter:blur(16px);

  border-bottom:
    1px solid rgba(255,255,255,0.08);
}

.navbar.scrolled{
  padding:12px 0;

  background:
    rgba(10,25,40,0.95);

  box-shadow:
    0 10px 30px rgba(0,0,0,0.15);
}

/* CONTAINER */

.navbar-container{
  display:flex;
  align-items:center;
  justify-content:space-between;
}

/* =========================
   LOGO
========================= */

.logo{
  display:flex;
  align-items:center;
  gap:14px;

  text-decoration:none;
}

.logo-wrapper img{
  width:60px;
  height:60px;

  object-fit:cover;

  border-radius:50%;

  border:3px solid #F0C95C;

  transition:0.4s;
}

.logo:hover img{
  transform:scale(1.08) rotate(-3deg);
}

.logo-text h2{
  margin:0;

  font-size:1.25rem;
  font-weight:800;

  color:white;
}

.logo-text span{
  font-size:0.8rem;
  color:#F0C95C;
}

/* =========================
   MENU
========================= */

.menu{
  display:flex;
  align-items:center;
  gap:30px;
}

.menu > a,
.dropdown > a{
  position:relative;

  display:flex;
  align-items:center;
  gap:8px;

  text-decoration:none;

  color:white;
  font-weight:600;

  transition:0.3s;
}

.nav-link-content{
  display:flex;
  align-items:center;
  gap:8px;
}

.menu > a i,
.dropdown > a i{
  color:#F0C95C;
}

.menu > a::after,
.dropdown > a::after{
  content:"";

  position:absolute;

  bottom:-8px;
  left:0;

  width:0;
  height:2px;

  background:#F0C95C;

  transition:0.4s;
}

.menu > a:hover::after,
.dropdown > a:hover::after,
.router-link-active::after{
  width:100%;
}

.menu > a:hover,
.dropdown > a:hover{
  color:#F0C95C;
}

/* =========================
   DROPDOWN
========================= */

.dropdown{
  position:relative;
}

.dropdown-icon{
  font-size:0.8rem;
  transition:0.3s;
}

.dropdown-icon.rotate{
  transform:rotate(180deg);
}

/* MENU */

.dropdown-menu{
  position:absolute;

  top:130%;
  left:0;

  min-width:280px;

  background:
    rgba(15,43,69,0.97);

  border:
    1px solid rgba(255,255,255,0.08);

  border-radius:20px;

  padding:12px;

  box-shadow:
    0 20px 50px rgba(0,0,0,0.2);

  opacity:0;
  visibility:hidden;

  transform:
    translateY(15px);

  transition:0.35s ease;

  list-style:none;
}

.dropdown-menu.show{
  opacity:1;
  visibility:visible;

  transform:
    translateY(0);
}

.dropdown-menu li{
  margin-bottom:5px;
}

.dropdown-menu li:last-child{
  margin-bottom:0;
}

.dropdown-menu li a{
  display:flex;
  align-items:center;
  gap:12px;

  padding:14px 16px;

  border-radius:14px;

  text-decoration:none;

  color:white;
  font-weight:500;

  transition:0.3s;
}

.dropdown-menu li a i{
  color:#F0C95C;
}

.dropdown-menu li a:hover{
  background:
    linear-gradient(
      90deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
}

.dropdown-menu li a:hover i{
  color:#0F2B45;
}

/* CONTACT BUTTON */

.contact-link{
  background:
    linear-gradient(
      90deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45 !important;

  padding:12px 22px;

  border-radius:50px;

  font-weight:700;
}

.contact-link:hover{
  transform:translateY(-3px);

  box-shadow:
    0 12px 30px rgba(240,201,92,0.3);
}

.contact-link::after{
  display:none;
}

/* =========================
   HAMBURGER
========================= */

.hamburger{
  display:none;

  flex-direction:column;
  gap:5px;

  cursor:pointer;
}

.hamburger span{
  width:28px;
  height:3px;

  background:#F0C95C;

  border-radius:10px;

  transition:0.3s;
}

.hamburger span.open:nth-child(1){
  transform:
    rotate(45deg)
    translate(5px,5px);
}

.hamburger span.open:nth-child(2){
  opacity:0;
}

.hamburger span.open:nth-child(3){
  transform:
    rotate(-45deg)
    translate(6px,-6px);
}

/* =========================
   RESPONSIVE
========================= */
/* =========================
   MOBILE DROPDOWN FIX (CADRE PROPRE)
========================= */

@media(max-width:992px){

  .dropdown{
    width:100%;
  }

  .dropdown > a{
    width:100%;
    justify-content:space-between;
    padding:14px 16px;
    border-radius:14px;
    background:rgba(255,255,255,0.04);
  }

  .dropdown > a:hover{
    background:rgba(255,255,255,0.08);
  }

  /* MENU MOBILE DROPDOWN */
  .dropdown-menu{
    position:relative !important;
    top:0;
    left:0;

    width:100%;
    min-width:100%;

    margin-top:8px;

    padding:8px;

    border-radius:14px;

    background:rgba(255,255,255,0.03);
    border:1px solid rgba(255,255,255,0.08);

    display:none;
  }

  .dropdown-menu.show{
    display:block;
  }

  .dropdown-menu li a{
    padding:12px 14px;
    border-radius:10px;
  }

  .dropdown-menu li a:hover{
    transform:translateX(6px);
  }
}

@media(max-width:992px){

  .hamburger{
    display:flex;
  }

  .menu{
  position:absolute;

  top:100%;
  right:20px;

  width:320px;

  max-height:calc(100vh - 110px);   /* hauteur maximale */
  overflow-y:auto;                  /* scroll vertical */
  overflow-x:hidden;

  background:rgba(10,25,40,0.98);

  border:1px solid rgba(255,255,255,0.08);

  border-radius:25px;

  padding:25px;

  flex-direction:column;
  align-items:flex-start;
  gap:20px;

  opacity:0;
  visibility:hidden;

  transform:translateY(-15px);

  transition:.35s ease;

  scrollbar-width:thin;
  scrollbar-color:#F0C95C transparent;
}
.dropdown-menu.show{
    display:block;

    max-height:280px;
    overflow-y:auto;

    scrollbar-width:thin;
    scrollbar-color:#F0C95C transparent;
}

  .menu.mobile-open{
    opacity:1;
    visibility:visible;

    transform:
      translateY(0);
  }

  .dropdown{
    width:100%;
  }

  .dropdown > a{
    width:100%;
    justify-content:space-between;
  }

  .dropdown-menu{
    position:relative;

    top:10px;

    width:100%;
    min-width:100%;

    display:none;
  }

  .dropdown-menu.show{
    display:block;
  }

  .contact-link{
    width:100%;
    justify-content:center;
  }

}

/* MOBILE */

@media(max-width:576px){

  .logo-text span{
    display:none;
  }

  .logo-text h2{
    font-size:1rem;
  }

  .logo-wrapper img{
    width:50px;
    height:50px;
  }

  .menu{
    width:calc(100% - 40px);
    right:20px;
  }

}
.menu::-webkit-scrollbar,
.dropdown-menu::-webkit-scrollbar{
    width:6px;
}

.menu::-webkit-scrollbar-thumb,
.dropdown-menu::-webkit-scrollbar-thumb{
    background:#F0C95C;
    border-radius:20px;
}

.menu::-webkit-scrollbar-track,
.dropdown-menu::-webkit-scrollbar-track{
    background:transparent;
}

</style>